import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import Logo from '../common/logo.js';
import constants from '../../const.js'

const ResetPassword = (props) => {

    var params = queryString.parse(props.location.search);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const resetPassword = async () => {
        var data = JSON.stringify({
            "email": email,
            "password": password,
        });
        var config = {
            method: 'post',
            url: `${constants.USER_API_URL}/auth/resetPwd`,
            headers: {
                'Authorization': `Bearer ${params.token}`,
                'Content-Type': 'application/json'
            },
            data: data
        };

        await axios(config).then(res => {
            if (res.status === 200) {
                setSuccess(true);
                setError('');
            } else {
                setError('Failed to reset password. Please try again.');
            }
        }).catch(err => {
            console.error(err);
            setError('Failed to reset password. Please try again.');
        }
        );
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!email) newErrors.email = 'Email is required.';
        if (!password) newErrors.password = 'Password is required.';
        if (!confirmPassword) newErrors.confirmPassword = 'Confirm password is required.';
        if (password && confirmPassword && password !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setError('Please fix the highlighted fields.');
            return;
        }

        setErrors({});
        setError('');
        resetPassword();
    }
    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Row className="w-100">
                <Col md={{ span: 6, offset: 3 }}>
                    <div className="p-4 border rounded shadow-sm bg-white">
                        <Logo />
                        <h2 className="text-center mb-4">Reset Password</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {success && <Alert variant="success">Password reset successfully. You can now log in.</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formEmail" className="mb-3">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={errors.email ? 'is-invalid' : ''}
                                />
                            </Form.Group>
                            <Form.Group controlId="formPassword" className="mb-3">
                                <Form.Label>New Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Enter new password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={errors.password ? 'is-invalid' : ''}
                                />
                            </Form.Group>
                            <Form.Group controlId="formConfirmPassword" className="mb-3">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    className={errors.confirmPassword ? 'is-invalid' : ''}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" className="w-100">
                                Reset Password
                            </Button>
                            <div className="text-center mt-3">
                                <Link to="/login">Back to Login</Link>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ResetPassword;